import Container from "@/components/Container/Container.tsx";
import { Accommodation } from "@/helpers/types/Accommodation.ts";
import { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";

interface ModalProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  previewAccommodation?: Accommodation;
}

const Modal = ({ children, isOpen, onClose }: ModalProps) => {
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".acc-preview-modal-content") && isOpen) {
        onClose();
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [onClose, isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <div className="acc-preview-modal-overlay c-accommodation-preview-modal-overlay"></div>
      <div className="acc-preview-modal-content c-accommodation-preview-modal">
        <Container>{children}</Container>
      </div>
    </>,
    document.body,
  );
};

export default Modal;
